<template>
    <div class="form-group">
        <label :for="myId" :class="labelWidth">{{ name | capitalize }}</label>
        <div v-if="isRow" :class="inputWidth">
            <input :type="type" class="form-control" :class="{'border-danger': myErrors.length}" :id="myId"
                :disabled="disabled" :placeholder="placeholder" :value="myValue" @input="update" @change="update">
        </div>
        <template v-else>
            <input :type="type" class="form-control" :class="{'border-danger': myErrors.length}" :id="myId"
                :disabled="disabled" :placeholder="placeholder" :value="myValue" @input="update" @change="update">
        </template>
        <div v-if="isRow" class="col-12">
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </div>
        <template v-else>
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </template>
    </div>
</template>
<script>
    import uuid from '../../library/uuid';
    import translator from '../../library/data-translator';

    export default {
        props: {
            id: {
                default: null
            },
            disabled: {
                default: false
            },
            name: {
                required: true
            },
            placeholder: {
                default: ''
            },
            rate: {
                default: '2-10'
            },
            type: {
                default: 'text'
            },
            unit: {
                default: 'sm'
            },
            value: {
                default: null
            }
        },
        data() {
            return {
                myId: null,
                uuid: uuid(),
                isRow: false,
                labelWidth: null,
                inputWidth: null,
                myValue: undefined,
                myErrors: []
            };
        },
        watch: {
            value(newValue, oldValue) {
                this.myValue = newValue;
            },
            errors: {
                deep: true,
                handler(newValue, oldValue) {
                    this.myErrors = newValue;
                }
            }
        },
        mounted() {
            this.myValue = this.value;
            let rateRule = /^(\d+)-(\d+)$/;
            let validRate = rateRule.test(this.rate);
            this.myId = this.id
                ? translator.toDashString(this.id) + '-' + this.uuid
                : this.uuid;
            this.$nextTick(() => {
                this.isRow = this.$el.classList.contains('row');
                if (this.isRow) {
                    let labelWidth, inputWidth, ratio;
                    let unit = ['', 'sm', 'md', 'lg', 'xl'].includes(this.unit) ? this.unit : '';
                    let values = (validRate ? this.rate : '2-10').match(rateRule);
                    labelWidth = Number(values[1]);
                    inputWidth = Number(values[2]);
                    ratio = 12 / (labelWidth + inputWidth);
                    labelWidth = Math.floor(labelWidth * ratio);
                    inputWidth = Math.floor(inputWidth * ratio);
                    this.labelWidth = 'col-' + (unit ? unit + '-' : '') + labelWidth;
                    this.inputWidth = 'col-' + (unit ? unit + '-' : '') + inputWidth;
                    this.labelWidth += ' col-form-label';
                }
            });
        },
        filters: {
            capitalize(value) {
                if (typeof value !== 'string') return value;
                return value[0].toUpperCase() + value.substr(1);
            }
        },
        methods: {
            update(e) {
                this.myErrors = [];
                this.$emit(e.type, e.target.value);
            }
        }
    }
</script>
<style lang="">

</style>